<template lang="html">
  <v-layout row>
    <v-layout column class="event">
      <chat-user-header :event="event"
                        :participants="participants">
        <template slot="headerIcon">
          <bqa-certificate-icon small :driver="driver" />
        </template>
        assigned the load's driver
      </chat-user-header>
      <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center>
          <span class="pl-4 font-weight-light">
            {{event.driverUserDisplayName}}
          </span>
      </v-flex>
      <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center v-if="event.bqaExpires">
          <span class="pl-4 font-weight-light">
            BQA Certification Expires {{event.bqaExpires | formatDay}}
          </span>
      </v-flex>
      <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center v-else>
          <span class="pl-4 font-weight-light font-italic">
            Not provided.
          </span>
      </v-flex>
      <v-flex xs12 sm2 v-if="showTime"
              class="text-sm-right text-sm-left event-line font-weight-light caption pr-2">
        <span>{{event.timestamp | formatDate}}</span>
      </v-flex>
    </v-layout>
    <div class="event-media" v-if="event.driverProfileImageUri">
      <a @click="openAttachment(event.driverProfileImageUri)">
        <img :src="getAttachmentUrl(event.driverProfileImageUri)" height="40"
             width="40" :id="`event-img-${event.driverProfileImageUri}`"/>
      </a>
    </div>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import BqaCertificateIcon from '@/components/BqaCertificateIcon';
import IconBase from '@/components/IconBase';
import IconPdf from '@/components/icons/IconPDF';
import ChatUserHeader from './ChatUserHeader';


export default {
  name: 'DriverAssignmentEvent',
  components: {
    IconBase,
    IconPdf,
    ChatUserHeader,
    BqaCertificateIcon,
  },
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    driver() {
      return {
        bqaCertification: {
          expires: this.event.bqaExpires,
          verified: this.event.bqaVerified,
          documentUri: this.event.bqaDocumentUri,
        },
      };
    },
  },
  created() {
    if (this.event.bqaDocumentUri) {
      this.getAttachmentUrl();
    }
  },
  methods: {
    async openAttachment(url) {
      this.$store.dispatch('lightbox/show', url);
    },
    async getAttachmentUrl() {
      // react-native image.prefetch component maybe?
      const response = await API.application.getDocument({ url: this.event.bqaDocumentUri });
      const eventImgEl = document.getElementById(`event-img-${this.event.bqaDocumentUri}`);
      if (eventImgEl) {
        eventImgEl.src = window.URL.createObjectURL(response);
      }
    },
  },
};
</script>
<style lang="css" scoped>
  .event {
    border-left: 3px #32CD32 solid;
  }
  .event-media {
    border-radius: 2px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/DriverAssignmentEvent.vue